import { render, staticRenderFns } from "./AgreementSelection.vue?vue&type=template&id=7975d0be&scoped=true&"
import script from "./AgreementSelection.vue?vue&type=script&lang=ts&"
export * from "./AgreementSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975d0be",
  null
  
)

export default component.exports